jQuery('.cookie-settings a').on('click', function () {
    CCM.openControlPanel();
});
